export const signUpBtn = {
  action: null,
  class: "MankSans-Medium",
  btnText: "Sign Up",
  placeholder: "Your email"
};

export const workAtDark = {
  type: "Center",
  class: "dark-purple-background",
  title: { text: "Work at Dark", class: "large-title white-text" },
  paragraph: [
    {
      class: "center-text white-text small-title",
      text:
        "We like our mission, but that isn’t the only thing that matters in a job. We want to make this a great place to work, and that means we care a lot about our core values, and we provide benefits that matter, like parental leave and full health care coverage for you and your dependents. And our office is wheelchair accessible."
    }
  ],
  centerAction: {
    type: "link",
    text: "Check out our job openings",
    url: "/careers",
    icon: "chevron-left",
    class: "blue-purple"
  }
};

export const tryDark = {
  type: "Center",
  class: "",
  title: { text: "Try Dark", class: "extra-large-title purple" },
  paragraph: [
    {
      class: "small-title justify-text dark-purple-text sm-width",
      text:
        "Dark is currently in private beta. Dark is ideal for developers building SPAs, mobile apps, new microservices in existing architectures, and internal tools."
    },
    {
      class: "small-title justify-text dark-purple-text sm-width",
      text:
        "We are working to open Dark to many more developers. We might give you access immediately if your project is well-scoped and you're ready to work on it right away."
    }
  ],
  centerAction: {
    type: "signup-btn",
    ...signUpBtn
  }
};

let headerItems = [
  {
    name: "Language",
    path: "/language",
    dropDown: [],
    specialClass: ""
  },
  {
    name: "About",
    path: "/about",
    dropDown: [],
    specialClass: ""
  },
  {
    name: "Careers",
    path: "/careers",
    dropDown: [
      { name: "team", path: "/" },
      { name: "values", path: "/" }
    ],
    specialClass: ""
  },
  {
    name: "Blog",
    path: "https://medium.com/darklang",
    external: true,
    dropDown: [],
    specialClass: ""
  },
  // Remove until page is ready
  // {
  //     name: "Log In",
  //     path: "/",
  //     dropDown: [],
  //     specialClass: ""
  // },
  {
    name: "Sign Up",
    path: "/beta",
    dropDown: [],
    specialClass: "cta-btn"
  }
];

const pageHeader = {
  "/": {
    class: "long",
    data: {
      title: {
        class: "extra-large-title page-header-text",
        text: "A language built for deployless backends"
      },
      emailForm: {
        ...signUpBtn,
        class: signUpBtn.class + " white-background",
        btnText: "Sign Up"
      }
    }
  },
  "/careers": {
    class: "wide-text",
    data: {
      title: {
        class: "extra-large-title",
        text:
          "We want this to be the best job we've had, and the best job you've had."
      }
    }
  },
  "/careers/benefits": {
    class: "wide-text",
    data: {
      title: {
        class: "extra-large-title",
        text:
          "We want this to be the best job we've had, and the best job you've had."
      }
    }
  },
  "/careers/interviewing": {
    class: "wide-text",
    data: {
      title: {
        class: "extra-large-title",
        text: "Interviewing at Dark"
      }
    }
  },
  "/careers/developer-experience": {
    class: "wide-text",
    data: {
      title: {
        class: "extra-large-title",
        text: "Developer Experience"
      }
    }
  },
  "/careers/software-engineer": {
    class: "wide-text",
    data: {
      title: {
        class: "extra-large-title",
        text: "Software Engineer"
      }
    }
  },
  "/careers/infrastructure-engineer": {
    class: "wide-text",
    data: {
      title: {
        class: "extra-large-title",
        text: "Infrastructure Engineer"
      }
    }
  },
  "/careers/frontend-engineer": {
    class: "wide-text",
    data: {
      title: {
        class: "extra-large-title",
        text: "Frontend Engineer"
      }
    }
  },
  "/careers/something-else": {
    class: "wide-text",
    data: {
      title: {
        class: "extra-large-title",
        text: "Something Else"
      }
    }
  },
  "/language": {
    class: "wide-text",
    data: {
      title: {
        class: "extra-large-title ",
        text:
          "Dark is a holistic programming language, structured editor, and infrastructure, for building backend web services"
      }
    }
  },
  "/about": {
    class: "wide-text",
    data: {
      title: {
        class: "extra-large-title",
        text:
          "Dark's mission is to democratize coding by making it 100x easier to build software, so the next billion people can code"
      }
    }
  },
  "/beta": {
    class: "wide-text",
    data: {
      title: {
        class: "extra-large-title",
        text: "Dark is currently in private beta"
      }
    }
  },
  "/login": {
    class: "short",
    data: {}
  },
  "/create-acc": {
    class: "short",
    data: {}
  },
  "/isUsernameAvailable": {
    class: "wide-text",
    data: {
      title: {
        class: "extra-large-title",
        text: "Check username availability "
      }
    }
  },
  "/signup": {
    class: "short",
    data: {}
  }
};

export const defaultPageHeader = {
  class: "medium",
  data: {
    title: {
      class: "extra-large-title",
      text: "Sorry, the page you are looking for must be lost in space"
    }
  }
};

export const headerData = {
  navBar: headerItems,
  pageHeadData: pageHeader
};

export const footerData = {
  copyright: "Copyright © 2019 Dark",
  socialLinks: [
    {
      name: "Github",
      link: "https://github.com/darklang",
      icon: "github"
    },
    {
      name: "Linkedin",
      link: "https://www.linkedin.com/company/darklang/",
      icon: "linkedin"
    },
    {
      name: "Medium",
      link: "https://medium.com/darklang",
      icon: "medium"
    },
    {
      name: "Twitter",
      link: "https://twitter.com/darklang",
      icon: "twitter"
    }
  ],
  linkCols: [
    {
      title: "Product",
      links: [
        {
          text: "Language",
          url: "/language"
        },
        {
          text: "FAQ",
          url: "/language#faq"
        },
        {
          text: "Sign Up",
          url: "/beta"
        },
        {
          text: "Sign In",
          url: "/login"
        }
        // {
        //     text: "Community",
        //     url: "/"
        // },
        // {
        //     text: "Testimonials",
        //     url: "/"
        // }
      ]
    },
    {
      title: "Company",
      links: [
        {
          text: "About",
          url: "/about"
        },
        {
          text: "Careers",
          url: "/careers"
        },
        {
          text: "Blog",
          url: "https://medium.com/darklang",
          external: true
        }
      ]
    }
  ]
};
